import React from "react";

import ContentAdminCategoria from "./ContentAdminCategoria";

const AdminCategoria = () => {
  return (
    <>
      <ContentAdminCategoria />
    </>
  );
};

export default AdminCategoria;
